<template>
  <div>
    <p class="body-1">
      {{ $t('This is a unique URL to your FAQ that can be shared with others') }}<br>
      <small>{{ $t('It uses the "Embed on page" method') }}</small>
    </p>

    <code-block
      :code="hostedUrl"
      class="mb-2"
      @copy-success="() => $root.$snack('success', 'Copied to clipboard', 1500)"
      @copy-error="() => $root.$snack('error', 'Could not copy to clipboard', 1500)"
    />

    <a
      :href="hostedUrl"
      target="_blank"
    >
      {{ $t('Open URL in new tab') }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    faq: {
      type: Object,
      required: true,
    },
    hostedUrl: {
      type: String,
      required: true
    }
  }
}
</script>